import * as React from 'react';
import { styled } from '@mui/material/styles';
import Switch, { switchClasses } from '@mui/material/Switch';

export const GreenSwitch = styled(Switch)(({ theme }) => ({
  width: 46,
  height: 26,
  padding: 0,
  display: 'inline-flex',
  [`& .${switchClasses.switchBase}`]: {
    padding: 0,
    margin: 2,
    transitionDuration: '200ms',
    [`&.${switchClasses.checked}`]: {
      transform: 'translateX(20px)',
      color: '#fff',
      [`& + .${switchClasses.track}`]: {
        backgroundColor: theme.palette.primary.main,
        opacity: 1,
      },
    },
  },
  [`& .${switchClasses.thumb}`]: {
    width: 22,
    height: 22,
    boxShadow: '0 3px 6px rgba(0,0,0,.2)',
    backgroundColor: '#fff',
  },
  [`& .${switchClasses.track}`]: {
    borderRadius: 26 / 2,
    backgroundColor: '#BDBDBD',
    opacity: 1,
  },
}));

export default function Demo() {
  const [on, setOn] = React.useState(true);
  return <GreenSwitch checked={on} onChange={(_, v) => setOn(v)} />;
}
